export default __webpack_public_path__ + "static/lga-a4f440fb6705c6b1bfbd8135a1e4c3ad.png";